import React, { useState } from "react";
import styles from "./WireTransfer.module.scss";
import Modal from "../Modal/Modal";
import { useFormik } from "formik";
import InputFormik from "../../Formik/Input/InputFormik";
import { Link } from "react-router-dom";
import Button from "../../Button/Button";
import WireTransferAccountNo from "../WireTransferAccountNo/WireTransferAccountNo";

const WireTransfer = ({ show, handleClose }) => {
  const [showAccountNumber, setShowAccountNumber] = useState(false);
  const formik = useFormik({
    initialValues: {
      routing_number: "",
    },
    onSubmit: (values) => { },
  });
  return (
    <>
      <Modal
        show={show}
        handleClose={handleClose}
        className={styles.wire_transfer}
        title="Wire Transfer"
      >
        <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <InputFormik
            name="routing_number"
            label="Enter your routing number"
            placeholder="123456789"
            {...formik.getFieldProps("routing_number")}
          />
          {formik.values.routing_number && (
            <span className={styles.bank_details}>
              Bank name: Big Bank || Bank address: Somewhere on earth.
            </span>
          )}
          <p>
            Enter your 9-digit bank routing number (ABA) so we can connect to
            your bank. Not sure where to find this?{" "}
            <Link to="">See an example</Link>
          </p>
          <Button
            fluid
            disabled={!formik.values.routing_number}
            type="button"
            onClick={() => {
              setShowAccountNumber(true);
              handleClose();
            }}
          >
            Continue
          </Button>
        </form>
      </Modal>
      <WireTransferAccountNo
        show={showAccountNumber}
        handleClose={() => setShowAccountNumber(false)}
      />
    </>
  );
};

export default WireTransfer;
